/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 30.08.13, 16:31
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
export class BrowserNames {
    public static UNAVAILABLE: string = "unavailable";

    public static FIREFOX: string = "Firefox";
    public static IE: string = "IE";
    public static IE7: string = "IE7";
    public static IE8: string = "IE8";
    public static IE9: string = "IE9";
    public static IE10: string = "IE10";
    public static IE11: string = "IE11";
    public static SAFARI: string = "Safari";
    public static OPERA: string = "Opera";
    public static CHROME: string = "Chrome";
}
